import { logger } from "core/logger";
import { Slot } from "core/types/index";
import { useTemplates } from "hooks/useTemplates";

export const useFilteredMeetingSlots = (slots: Slot[]) => {
  const { data: templates, isFetched } = useTemplates();

  const templateMap = new Map(
    templates.map((template) => [template.templateId, template]),
  );

  return slots
    .filter((slot) => {
      if (!isFetched) return false;

      const template = templateMap.get(slot.templateId);

      if (!template) {
        logger.error("No template found for slot", { slotId: slot.slotId });
        return false;
      }

      if (template.name === "tech_test") {
        // isMeeting for tech_test is true so this needs to be treated explicitly...
        return false;
      }
      const isCanceled =
        slot.status === "CANCELED" || slot.status === "LATE_CANCELED";

      return template.isMeeting && !isCanceled;
    })
    .map((slot) => {
      return slot.status;
    });
};
